import { useMutation } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { MutationConfig } from 'src/lib/react-query';
import { GeneralSmartParkError } from 'src/registry/types/axios';
import { formatResourcePath } from 'src/utils/regex';
import { STORAGE_PREFIX } from 'src/config';

const RESOURCE = `${STORAGE_PREFIX}/:parkingId/sites/zone/:zoneId/`;

type MutationFnType = typeof mutationFn;

interface DTO {
    zoneId: string;
    parkingId: string;
}
const mutationFn = ({ zoneId, parkingId }: DTO): Promise<void> => {
    return axios.delete(formatResourcePath(RESOURCE, { zoneId, parkingId }));
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralSmartParkError>) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useDeleteZone };
